/**
 * An array of product variants.
 * Each variant object contains details about a specific product variant.
 * 
 * @typedef {Object} Variant
 * @property {number} id - The unique identifier for the variant.
 * @property {number} product_id - The unique identifier for the product.
 * @property {string} option1 - The first option for the variant (coffee type).
 * @property {string} option2 - The second option for the variant (quantity).
 * @property {string} price - The price of the variant.
 * 
 * @type {Variant[]}
 */
var variants = [
  
  {
    "id": 31958197796906,
    "product_id": 4569407586346,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "91.20"
  },
  
  {
    "id": 31958197829674,
    "product_id": 4569407586346,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "154.40"
  },
  
  {
    "id": 31958197862442,
    "product_id": 4569407586346,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "244.80"
  },
  
  {
    "id": 31958197600298,
    "product_id": 4569407586346,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "102.00"
  },
  
  {
    "id": 31958197633066,
    "product_id": 4569407586346,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "176.00"
  },
  
  {
    "id": 31958197665834,
    "product_id": 4569407586346,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "288.00"
  },
  
  {
    "id": 31958197698602,
    "product_id": 4569407586346,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "91.20"
  },
  
  {
    "id": 31958197731370,
    "product_id": 4569407586346,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "154.40"
  },
  
  {
    "id": 31958197764138,
    "product_id": 4569407586346,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "244.80"
  },
  
  {
    "id": 31958197895210,
    "product_id": 4569407586346,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "94.80"
  },
  
  {
    "id": 31958197927978,
    "product_id": 4569407586346,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "161.60"
  },
  
  {
    "id": 31958197960746,
    "product_id": 4569407586346,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "259.20"
  },
  
  {
    "id": 31957872574506,
    "product_id": 4569313542186,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "18.00"
  },
  
  {
    "id": 31957872607274,
    "product_id": 4569313542186,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "36.00"
  },
  
  {
    "id": 31957872640042,
    "product_id": 4569313542186,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "72.00"
  },
  
  {
    "id": 31957872672810,
    "product_id": 4569313542186,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "15.30"
  },
  
  {
    "id": 31957872705578,
    "product_id": 4569313542186,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "30.60"
  },
  
  {
    "id": 31957872738346,
    "product_id": 4569313542186,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "61.20"
  },
  
  {
    "id": 31957872771114,
    "product_id": 4569313542186,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "15.30"
  },
  
  {
    "id": 31957872803882,
    "product_id": 4569313542186,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "30.60"
  },
  
  {
    "id": 31957872836650,
    "product_id": 4569313542186,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "61.20"
  },
  
  {
    "id": 31957872869418,
    "product_id": 4569313542186,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "16.20"
  },
  
  {
    "id": 31957872902186,
    "product_id": 4569313542186,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "32.40"
  },
  
  {
    "id": 31957872934954,
    "product_id": 4569313542186,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "64.80"
  },
  
  {
    "id": 31958186131498,
    "product_id": 4569405227050,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "102.00"
  },
  
  {
    "id": 31958186164266,
    "product_id": 4569405227050,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "176.00"
  },
  
  {
    "id": 31958186197034,
    "product_id": 4569405227050,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "288.00"
  },
  
  {
    "id": 31958186229802,
    "product_id": 4569405227050,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "91.20"
  },
  
  {
    "id": 31958186262570,
    "product_id": 4569405227050,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "154.40"
  },
  
  {
    "id": 31958186295338,
    "product_id": 4569405227050,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "244.80"
  },
  
  {
    "id": 31958186328106,
    "product_id": 4569405227050,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "91.20"
  },
  
  {
    "id": 31958186360874,
    "product_id": 4569405227050,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "154.40"
  },
  
  {
    "id": 31958186393642,
    "product_id": 4569405227050,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "244.80"
  },
  
  {
    "id": 31958186426410,
    "product_id": 4569405227050,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "94.80"
  },
  
  {
    "id": 31958186459178,
    "product_id": 4569405227050,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "161.60"
  },
  
  {
    "id": 31958186491946,
    "product_id": 4569405227050,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "259.20"
  },
  
  {
    "id": 31958199238698,
    "product_id": 4569407717418,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "102.00"
  },
  
  {
    "id": 31958199271466,
    "product_id": 4569407717418,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "176.00"
  },
  
  {
    "id": 31958199304234,
    "product_id": 4569407717418,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "288.00"
  },
  
  {
    "id": 31958199337002,
    "product_id": 4569407717418,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "91.20"
  },
  
  {
    "id": 31958199369770,
    "product_id": 4569407717418,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "154.40"
  },
  
  {
    "id": 31958199402538,
    "product_id": 4569407717418,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "244.80"
  },
  
  {
    "id": 31958199435306,
    "product_id": 4569407717418,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "91.20"
  },
  
  {
    "id": 31958199468074,
    "product_id": 4569407717418,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "154.40"
  },
  
  {
    "id": 31958199500842,
    "product_id": 4569407717418,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "244.80"
  },
  
  {
    "id": 31958199533610,
    "product_id": 4569407717418,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "94.80"
  },
  
  {
    "id": 31958199566378,
    "product_id": 4569407717418,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "161.60"
  },
  
  {
    "id": 31958199599146,
    "product_id": 4569407717418,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "259.20"
  },
  
  {
    "id": 31958033694762,
    "product_id": 4569368494122,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "204.00"
  },
  
  {
    "id": 31958033727530,
    "product_id": 4569368494122,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "352.00"
  },
  
  {
    "id": 31958033760298,
    "product_id": 4569368494122,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "576.00"
  },
  
  {
    "id": 31958033825834,
    "product_id": 4569368494122,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "182.40"
  },
  
  {
    "id": 31958033858602,
    "product_id": 4569368494122,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "308.80"
  },
  
  {
    "id": 31958033891370,
    "product_id": 4569368494122,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "489.60"
  },
  
  {
    "id": 31958033924138,
    "product_id": 4569368494122,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "182.40"
  },
  
  {
    "id": 31958033956906,
    "product_id": 4569368494122,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "308.80"
  },
  
  {
    "id": 31958033989674,
    "product_id": 4569368494122,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "489.60"
  },
  
  {
    "id": 31958034022442,
    "product_id": 4569368494122,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "189.60"
  },
  
  {
    "id": 31958034055210,
    "product_id": 4569368494122,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "323.20"
  },
  
  {
    "id": 31958034087978,
    "product_id": 4569368494122,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "518.40"
  },
  
  {
    "id": 31958092415018,
    "product_id": 4569378717738,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "204.00"
  },
  
  {
    "id": 31958092447786,
    "product_id": 4569378717738,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "352.00"
  },
  
  {
    "id": 31958092480554,
    "product_id": 4569378717738,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "576.00"
  },
  
  {
    "id": 31958092513322,
    "product_id": 4569378717738,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "182.40"
  },
  
  {
    "id": 31958092546090,
    "product_id": 4569378717738,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "308.80"
  },
  
  {
    "id": 31958092578858,
    "product_id": 4569378717738,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "489.60"
  },
  
  {
    "id": 31958092611626,
    "product_id": 4569378717738,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "182.40"
  },
  
  {
    "id": 31958092644394,
    "product_id": 4569378717738,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "308.80"
  },
  
  {
    "id": 31958092677162,
    "product_id": 4569378717738,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "489.60"
  },
  
  {
    "id": 31958092709930,
    "product_id": 4569378717738,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "189.60"
  },
  
  {
    "id": 31958092742698,
    "product_id": 4569378717738,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "323.20"
  },
  
  {
    "id": 31958092775466,
    "product_id": 4569378717738,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "518.40"
  },
  
  {
    "id": 31958089629738,
    "product_id": 4569378291754,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "204.00"
  },
  
  {
    "id": 31958089662506,
    "product_id": 4569378291754,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "352.00"
  },
  
  {
    "id": 31958089695274,
    "product_id": 4569378291754,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "576.00"
  },
  
  {
    "id": 31958089728042,
    "product_id": 4569378291754,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "182.40"
  },
  
  {
    "id": 31958089760810,
    "product_id": 4569378291754,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "308.80"
  },
  
  {
    "id": 31958089793578,
    "product_id": 4569378291754,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "489.60"
  },
  
  {
    "id": 31958089826346,
    "product_id": 4569378291754,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "182.40"
  },
  
  {
    "id": 31958089859114,
    "product_id": 4569378291754,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "308.80"
  },
  
  {
    "id": 31958089891882,
    "product_id": 4569378291754,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "489.60"
  },
  
  {
    "id": 31958089924650,
    "product_id": 4569378291754,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "189.60"
  },
  
  {
    "id": 31958089957418,
    "product_id": 4569378291754,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "323.20"
  },
  
  {
    "id": 31958089990186,
    "product_id": 4569378291754,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "518.40"
  },
  
  {
    "id": 31958183772202,
    "product_id": 4569404637226,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "306.00"
  },
  
  {
    "id": 31958183804970,
    "product_id": 4569404637226,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "528.00"
  },
  
  {
    "id": 31958183837738,
    "product_id": 4569404637226,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "864.00"
  },
  
  {
    "id": 31958183870506,
    "product_id": 4569404637226,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "273.60"
  },
  
  {
    "id": 31958183903274,
    "product_id": 4569404637226,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "463.20"
  },
  
  {
    "id": 31958183936042,
    "product_id": 4569404637226,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "734.40"
  },
  
  {
    "id": 31958183968810,
    "product_id": 4569404637226,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "273.60"
  },
  
  {
    "id": 31958184001578,
    "product_id": 4569404637226,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "463.20"
  },
  
  {
    "id": 31958184034346,
    "product_id": 4569404637226,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "734.40"
  },
  
  {
    "id": 31958184067114,
    "product_id": 4569404637226,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "284.40"
  },
  
  {
    "id": 31958184099882,
    "product_id": 4569404637226,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "484.80"
  },
  
  {
    "id": 31958184132650,
    "product_id": 4569404637226,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "777.60"
  },
  
  {
    "id": 31958097592362,
    "product_id": 4569379602474,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "306.00"
  },
  
  {
    "id": 31958097625130,
    "product_id": 4569379602474,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "528.00"
  },
  
  {
    "id": 31958097657898,
    "product_id": 4569379602474,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "864.00"
  },
  
  {
    "id": 31958097690666,
    "product_id": 4569379602474,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "273.60"
  },
  
  {
    "id": 31958097723434,
    "product_id": 4569379602474,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "463.20"
  },
  
  {
    "id": 31958097756202,
    "product_id": 4569379602474,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "734.40"
  },
  
  {
    "id": 31958097788970,
    "product_id": 4569379602474,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "273.60"
  },
  
  {
    "id": 31958097821738,
    "product_id": 4569379602474,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "463.20"
  },
  
  {
    "id": 31958097854506,
    "product_id": 4569379602474,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "734.40"
  },
  
  {
    "id": 31958097887274,
    "product_id": 4569379602474,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "284.40"
  },
  
  {
    "id": 31958097920042,
    "product_id": 4569379602474,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "484.80"
  },
  
  {
    "id": 31958097952810,
    "product_id": 4569379602474,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "777.60"
  },
  
  {
    "id": 31958151430186,
    "product_id": 4569397035050,
    "option1": "Roaster's Choice",
    "option2": "1 Box",
    "price": "306.00"
  },
  
  {
    "id": 31958151462954,
    "product_id": 4569397035050,
    "option1": "Roaster's Choice",
    "option2": "2 Boxes",
    "price": "528.00"
  },
  
  {
    "id": 31958151495722,
    "product_id": 4569397035050,
    "option1": "Roaster's Choice",
    "option2": "4 Boxes",
    "price": "864.00"
  },
  
  {
    "id": 31958151528490,
    "product_id": 4569397035050,
    "option1": "Prospect",
    "option2": "1 Box",
    "price": "273.60"
  },
  
  {
    "id": 31958151561258,
    "product_id": 4569397035050,
    "option1": "Prospect",
    "option2": "2 Boxes",
    "price": "463.20"
  },
  
  {
    "id": 31958151594026,
    "product_id": 4569397035050,
    "option1": "Prospect",
    "option2": "4 Boxes",
    "price": "734.40"
  },
  
  {
    "id": 31958151626794,
    "product_id": 4569397035050,
    "option1": "Wallabout",
    "option2": "1 Box",
    "price": "273.60"
  },
  
  {
    "id": 31958151659562,
    "product_id": 4569397035050,
    "option1": "Wallabout",
    "option2": "2 Boxes",
    "price": "463.20"
  },
  
  {
    "id": 31958151692330,
    "product_id": 4569397035050,
    "option1": "Wallabout",
    "option2": "4 Boxes",
    "price": "734.40"
  },
  
  {
    "id": 31958151725098,
    "product_id": 4569397035050,
    "option1": "Decaf",
    "option2": "1 Box",
    "price": "284.40"
  },
  
  {
    "id": 31958151757866,
    "product_id": 4569397035050,
    "option1": "Decaf",
    "option2": "2 Boxes",
    "price": "484.80"
  },
  
  {
    "id": 31958151790634,
    "product_id": 4569397035050,
    "option1": "Decaf",
    "option2": "4 Boxes",
    "price": "777.60"
  }

];

var pay_in_advance_ids = {
  duration1: {
    frequency1: 4569405227050, // every 1 weeks, 4 shipments
    frequency2: 4569407717418, // every 2 weeks, 4 shipments
    frequency3: 4569407586346, // every 4 weeks, 4 shipments
  },
  duration2: {
    frequency1: 4569368494122, // every 1 weeks, 8 shipments
    frequency2: 4569378717738, // every 2 weeks, 8 shipments
    frequency3: 4569378291754, // every 4 weeks, 8 shipments
  },
  duration3: {
    frequency1: 4569404637226, // every 1 weeks, 12 shipments
    frequency2: 4569379602474, // every 2 weeks, 12 shipments
    frequency3: 4569397035050, // every 4 weeks, 12 shipments
  },
};

// Updated selling plan IDs from Shopify (as of 2025/01/11)
// NOTE: The current subscription product only has pay-as-you-go plans
// There are no separate plans for different durations (4/8/12 shipments)
var selling_plan_ids = {
  // These IDs are used for all durations since there's only one plan per frequency
  payAsYouGo: {
    frequency1: 32419250396, // Delivery every 1 week
    frequency2: 32419283164, // Delivery every 2 weeks
    frequency3: 32419315932, // Delivery every 4 weeks
  },
  // Legacy structure maintained for compatibility
  duration1: {
    frequency1: 32418660572, // Delivery every 1 week
    frequency2: 32419217628, // Delivery every 2 weeks
    frequency3: 32418791644, // Delivery every 4 weeks
  },
  duration2: {
    frequency1: 32419578076, // Delivery every 1 week
    frequency2: 32419348700, // Delivery every 2 weeks
    frequency3: 32419086556, // Delivery every 4 weeks
  },
  duration3: {
    frequency1: 32418627804, // Delivery every 1 week
    frequency2: 32418562268, // Delivery every 2 weeks
    frequency3: 32418955484, // Delivery every 4 weeks
  },
};

/**
 * Figure out the variant id based on current selections in form
 *
 * @return  {int}  pay in advance id
 */
function determine_id() {
  let radio_type = $('input[name="type"]:checked');
  let idVal = radio_type.attr("id");
  if (idVal == "type2") {
    return 4569313542186;
  } else {
    let duration = $('input[name="duration"]:checked').attr("id");
    let frequency = $('input[name="frequency"]:checked').attr("id");
    return pay_in_advance_ids[duration][frequency];
  }
}

/**
 * Figure out the selling plan id based on current selections in form
 *
 * @return  {int}  selling plan id
 */
function determine_selling_plan_id() {
  let radio_type = $('input[name="type"]:checked');
  let idVal = radio_type.attr("id");
  let frequency = $('input[name="frequency"]:checked').attr("id");
  
  // For Pay As You Go, use the frequency-based selling plan
  if (idVal == "type2") {
    return selling_plan_ids.payAsYouGo[frequency];
  } else {
    // For Pay in Advance, also use frequency-based plan (no duration-specific plans available)
    let duration = $('input[name="duration"]:checked').attr("id");
    return selling_plan_ids[duration][frequency];
  }
}

/**
 * Figure out the product details based on the Variant ID
 *
 * @return  {int}  Subset ID
 */
function determine_variant() {
  let selection = $('input[name="select"]:checked').val();
  let quantity = $('input[name="quantity"]:checked').val();

  let productId = determine_id();

  let subset = variants.filter((variant) => variant.product_id == productId);
  subset = subset.filter((variant) => variant.option1.startsWith(selection));
  subset = subset.filter((variant) => variant.option2.startsWith(quantity));

  if (subset.length === 0) {
    subset = variants.filter(
      (variant) =>
        variant.product_id == productId &&
        variant.option1.toLowerCase().includes(selection.toLowerCase()) &&
        variant.option2.toLowerCase().includes(quantity.toLowerCase())
    );
  }

  if (subset.length > 0) {
    return subset[0].id;
  } else {
    return null;
  }
}

function updateSelection() {
  let paymentType = $('input[name="type"]:checked').val();
  let selection = $('input[name="select"]:checked').val();
  let quantity = $('input[name="quantity"]:checked').val();
  let frequency = $('input[name="frequency"]:checked').val();
  let duration = $('input[name="duration"]:checked').val();

  $("li.type span").text(paymentType);
  $("li.select span").text(selection);
  $("li.quantity span").text(quantity);
  $("li.frequency span").text(frequency ? frequency + " weeks" : "");
  $("li.duration span").text(duration ? duration + " shipments" : "N/A");

  if (paymentType === "Pay As You Go") {
    $("#step5").hide();
    $("li.duration").hide();
  } else {
    $("#step5").show();
    $("li.duration").show();
  }

  if (
    selection &&
    quantity &&
    frequency &&
    (paymentType === "Pay As You Go" || duration)
  ) {
    let variantID = determine_variant();
    if (variantID) {
      let chosenVariant = variants.find((variant) => variant.id == variantID);
      if (chosenVariant) {
        let price = chosenVariant.price;
        let nicePrice =
          paymentType === "Pay As You Go"
            ? "$" + price + " per shipment"
            : "$" + price;
        $("#finish h3 span").text(nicePrice);
      } else {
        $("#finish h3 span").text("Price not available");
      }
    } else {
      $("#finish h3 span").text("Price not available");
    }
  } else {
    $("#finish h3 span").text("");
  }
}

function addItemToCart(variant_id, qty, selling_plan_id) {
  let data = {
    items: [
      {
        id: variant_id,
        quantity: qty,
      },
    ],
  };

  // Only add selling_plan if it's provided
  if (selling_plan_id) {
    data.items[0].selling_plan = selling_plan_id;
  }

  console.log("Adding to cart:", data);

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: JSON.stringify(data),
    contentType: "application/json",
    dataType: "json",
    cache: false,
    headers: { "cache-control": "no-cache" },
    success: function (response) {
      window.location.href = "/cart";
    },
    error: function (jqXHR, textStatus, errorThrown) {
      console.error("Cart error:", jqXHR.responseJSON);
      alert(
        "There was an error adding the item to your cart. Please try again or contact support."
      );
    },
  });
}

$(function () {
  $('input[type="radio"]').change(updateSelection);

  updateSelection();

  $("#add-to-cart-button").click(function () {
    let quantity = parseInt($('input[name="quantity"]:checked').val(), 10);
    let intervalFrequency = $('input[name="frequency"]:checked').val();
    let variantID = determine_variant();
    let subscriptionType = "Subscription";
    let sellingPlanID = determine_selling_plan_id();
    
    console.log("Subscribe clicked:", {
      variantID: variantID,
      sellingPlanID: sellingPlanID,
      paymentType: $('input[name="type"]:checked').val()
    });
    
    if (sellingPlanID) {
      quantity = 1;
      addItemToCart(variantID, quantity, sellingPlanID);
    } else {
      alert(
        "Sorry, we couldn't find a matching subscription plan. Please try again or contact support."
      );
    }
  });
});

/* Hide/show duration options based on payment type */
$(document).ready(function() {
  $('input[type="radio"][name="type"]').change(function() {
    if ($(this).val() === "Pay As You Go") {
      $('#step5').hide();
      $('li.duration').hide();
    } else {
      $('#step5').show();
      $('li.duration').show();
    }
  });

  // Initial check on page load
  if ($('input[type="radio"][name="type"]:checked').val() === "Pay As You Go") {
    $('#step5').hide();
    $('li.duration').hide();
  }
});
